<template>
  <div class="w-full h-full overflow-hidden">
    <!-- <Step class="mb-40px" :steps="steps" v-model="step" /> -->
    <el-form
      class="w-800px m-auto my-0"
      :model="modelForm"
      :rules="rules"
      ref="ruleForm"
      v-if="step == 0"
      :before-close="close"
    >
    <el-form-item
        label="选择镜像"
        prop="image_version_biz_id"
        style="position: relative;"
      
      >
        <el-select v-model="modelForm.image_version_biz_id" placeholder="选择镜像" @visible-change="imagefocus" @change="imageselect">
          <el-option
            v-for="(item, index) in imagedatalist"
            :key="index"
            :label="item.image_name"
            :value="item.image_version_biz_id"
            @click.native="imgc(item)"
            
          ></el-option>
        </el-select>
        <el-checkbox v-model="checked" style="position: absolute; right: -0.6rem;" @change="checkuserimage" v-if="!selectdevimgbizid">自定义镜像</el-checkbox>
      </el-form-item>
      <el-form-item label="开发环境名称"  prop="serving_name_zh" >
        <el-input
          v-model="modelForm.serving_name_zh"
          maxlength="100"
          show-word-limit
          :disabled="modelsever?modelsever.runmodeltype==1:false"
        />
      </el-form-item>
      <!-- <el-form-item label="英文名称" prop="serving_name_en">
        <el-input
          v-model="modelForm.serving_name_en"
          :disabled="modelForm.id > -1||modelNameDisable ||modelsever?modelsever.runmodeltype==1:false"
          placeholder=""
          maxlength="100"
          show-word-limit
          
        />
      </el-form-item> -->
      <el-form-item label="开发环境标签" prop="serving_category_id">
        <select-model-type
          v-model="modelForm.serving_category_id"
          :props="{ expandTrigger: 'hover' }"
          :options="typeList"
        ></select-model-type>
      </el-form-item>
      <el-form-item label="开发环境简介">
        <el-input
          v-model="modelForm.serving_intro"
          type="textarea"
          placeholder="请填写任务简介"
          :rows="3"
          maxlength="100"
          show-word-limit
          class="text-0.1rem"
        ></el-input>
      </el-form-item>
      <el-form-item label="发布者" prop="publisher_id">
        <el-select v-model="modelForm.publisher_id" :disabled="modelForm.id > -1">
          <el-option
            v-for="(item, index) in ownerOptions"
            :key="index"
            :label="item.name"
            :value="item.id"
            :disabled="modelsever?modelsever.runmodeltype==1:false"
          ></el-option>
        </el-select> 
      </el-form-item>

      
      <!-- <el-form-item
        label="选择镜像"
        prop="image_version_biz_id"
        style="position: relative;"
        v-if="checked"
      >
        <el-select v-model="modelForm.image_version_biz_id" placeholder="选择自定义镜像" @visible-change="imagefocus" @change="imageselect">
          <el-option
            v-for="(item, index) in imagedatalist"
            :key="index"
            :label="item.image_name"
            :value="item.biz_id"
            @click.native="imgc(item)"
            
          ></el-option>
        </el-select>
        <el-checkbox v-model="checked" style="position: absolute; right: -0.6rem;" @change="checkuserimage">自定义镜像</el-checkbox>
      </el-form-item> -->
      <el-form-item label="资源配置" prop="xpu_id">
        <el-select v-model="modelForm.xpu_id" placeholder="请选择">
          <el-option
            v-for="(item, index) in xpuList"
            :key="index"
            :label="item.xpu_name"
            :value="item.id"
            @click.native="xpuChange(item)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="训练模式" prop="train_mode">
  
        <el-radio v-model="modelForm.train_mode" :label="1" @input="getinput"
          >单点式</el-radio
        >
        <el-radio v-model="modelForm.train_mode" :label="2" @input="getinput" :disabled="maxnode<=1"
          >分布式</el-radio
        >
        <span style="color: red;" v-if="maxnode===1">当前资源不足无法选择分布式仅支持单点式</span>
        <span style="color: red;" v-if="maxnode===0 && gpu_num>0">当前资源不足</span>
      </el-form-item>
      <el-form-item
        label="节点数"
        prop="replicas"
        v-if=" modelForm.train_mode == 2"
      >
      <el-input-number v-model="modelForm.replicas"  :min="2" :max="maxnode" label="描述文字" size="medium" @input="setreplicas"></el-input-number>
      <el-popover
            placement="right"
            title="提示"
            width="100"
            trigger="hover"
            class="tips"
          >
            <div>
              若需更多节点请联系客服
            </div>
            <img
              src="@/assets/images/information.png"
              class="w-19px h-19px ml-10px"
              slot="reference"
            />
          </el-popover>
      </el-form-item>
      <el-form-item
        label="模型文件"
        prop="model_path"
      >
        <el-input
          v-model="modelForm.model_path"
          :placeholder="modelForm.model_path?modelForm.model_path:'选择文件路径'"
          show-word-limit
          @focus="addmodelfile('model')"
          :disabled="modelForm.model_path!=''"
         
        />
        <el-button class="ml-0.1rem" v-if="modelForm.model_path " @click="delmodelfile" type="danger">删除</el-button>
        <el-popover
            placement="right"
            title="提示"
            width="100"
            trigger="hover"
            class="tips"
          >
            <div>
              仅支持引用始智AI平台存储的模型文件 
            </div>
            <img
              src="@/assets/images/information.png"
              class="w-19px h-19px ml-10px"
              slot="reference"
            />
          </el-popover>
      </el-form-item>
      <!-- <el-form-item
        label="数据集文件"
        prop="Datasetfile"
        v-if="jingxiangstatus == 1 "
      >
        <el-input
          v-model="modelForm.Datasetfile"
          :placeholder="modelForm.Datasetfile?modelForm.Datasetfile:'选择文件路径'"
          show-word-limit
          @focus="addmodelfile('data')"
          :disabled="modelForm.Datasetfile!=''"
         
        />
        <el-button class="ml-0.1rem" v-if="modelForm.Datasetfile" @click="modelForm.Datasetfile=''" type="danger">删除</el-button>
        <el-popover
            placement="right"
            title="提示"
            width="100"
            trigger="hover"
            class="tips"
          >
            <div>
              仅支持引用始智AI平台存储的数据集文件
            </div>
            <img
              src="@/assets/images/information.png"
              class="w-19px h-19px ml-10px"
              slot="reference"
            />
          </el-popover>
      </el-form-item> -->
    </el-form>
    <div class="w-900px m-auto my-0" v-if="showprice">
      <el-form
      class="w-800px m-auto my-0"
      :model="modelForm"
      :rules="rules"
      ref="ruleForms"
      v-if="step == 0"
      :before-close="close"
    >
    <el-form-item label="计费方式" prop="xpu_price_conf_id">
        <el-radio
          v-model="modelForm.xpu_price_conf_id"
          v-for="item in payList"
          :key="item.id"
          :label="item.id"
          @input="payChange(item)"
          >{{ item.type_name }}</el-radio
        >
      </el-form-item>
      <el-form-item label="配置费用" prop="time_range_id">
        <div  style="color: #333333; font-size: 0.1rem;"><span v-if="modelForm.train_mode == 2" >{{ modelForm.replicas }}*</span>{{ payfee }}元/{{ payUnit }}</div>
        <el-popover
          placement="right"
          title="提示"
          width="340"
          trigger="hover"
          v-show="!showTime"
        >
          <div>
            快到期时可以到“用户中心-我的资源-开发环境”中进行续费<br />
            预付费资源暂时不支持手动停止
          </div>
          <img
            src="@/assets/images/information.png"
            class="w-19px h-19px ml-10px"
            slot="reference"
          />
        </el-popover>
      </el-form-item>
      <el-form-item label="停止时间" prop="time_range_id" v-show="showTime">
        <el-select v-model="modelForm.time_range_id" placeholder="请选择">
            <el-option
              v-for="(item, index) in timeRangeList"
              :key="index"
              :label="item.time_range_desc"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-popover
            placement="right"
            title="提示"
            width="340"
            trigger="hover"
          >
            <div>
              您可以到"用户中心-我的资源-体验"中随时停止<br />
              体验运行中将每小时自动从账户余额中扣除相应费用
            </div>
            <img
              src="@/assets/images/information.png"
              class="w-19px h-19px ml-10px"
              slot="reference"
            />
          </el-popover>
        </el-form-item>
      <el-form-item label="账户余额" >
          <span  style="color: #333333; font-size: 0.1rem;">￥{{ belence }}</span>
          <div class="flex items-center ml-20px" v-if="noMony">
            <img src="@/assets/images/warning.png" class="warning-icon" />
            <span class="money-warning">余额不足，请充值</span>
            <div class="ml-10px pay-btn" @click="pay">充值</div>
            <div class="ml-10px pay-btn" @click="flushAccount">刷新</div>
          </div>
        </el-form-item>
  </el-form>


    </div>
    
    <div class="flex footer">
      <!-- <el-button
        type="primary"
        @click="nextFn"
        v-if="step == 0"
        :disabled="disable"
        >{{ jingxiangstatus == 1 ? '下一步' : '确认' }}</el-button
      >
      <el-button type="primary" @click="backFn" v-if="step == 1"
        >上一步</el-button
      > -->
      <el-button
        type="primary"
        :disabled="disable || noMony"
        @click="finishFn"
        data-umami-event="创建开发环境-提交订单"
        >提交订单</el-button
      >
    </div>
    
    <el-dialog
      title=""
      append-to-body
      :visible.sync="modelVisible"
      width="7rem"
      :before-close="closeModel"
    >
      <div class="flex flex-col">
        <payMent @close_pay="closeModel" class="p-50px"></payMent>
      </div>
    </el-dialog>
    <el-dialog
      :title="addfiletype=='model'?'添加模型文件路径':'添加数据集文件路径'"
      append-to-body
      :visible.sync="filemodel"
      width="4rem"
      :before-close="closefile"
    >
          <fileselect @finish="finiFN" :type="addfiletype" ref="fileaddress"></fileselect>
    </el-dialog>
  </div>
</template>

<script>
import fileselect from './fileselect/index.vue'
import payMent from '@/views/individual-center/my-account/payment/payment.vue'
import getFullByLastIdFromTree from '@/utils/getFullByLastIdFromTree'
import selectModelType from '@/components/select-model-type.vue'
import Step from '@/components/step.vue'
import { valiEngName } from '@/utils/validate'
import array2Tree from '@/utils/arrayToTree'
import { getModelImage } from '@/utils/getSelectOptions'
export default {
  components: { selectModelType, Step, payMent ,fileselect},
  props: {
    checkImg: {}, //从模型详情页面创建默认选中一个镜像
    correlation: {},
    modelsever:{},
    tuning_code_path:{},
    selectdevimgbizid:{}//镜像列表选中镜像的id
  },
  data() {
    const engNameValidate = (rule, value, callback) => {
      const { status, message } = valiEngName(value)

      if (!status) {
        callback(message)
      } else {
        callback()
      }
    }
    return {
      modelNameDisable:false,
      xpuList: [],
      modelVisible: false,
      filemodel:false,
      disable: false,
      step: 0,
      imagedatalist:[],
      steps: [
        { iconClass: 'jcxx', name: '基础信息' },
        { iconClass: 'szsx', name: '确认订单' }
      ],
      rules: {
        serving_name_zh: [
          { required: true, message: '请输入开发环境名称', trigger: 'blur' }
        ],
        // serving_name_en: [
        //   {
        //     required: true,
        //     message: '请填写开发环境英文名称',
        //     validator: engNameValidate,
        //     trigger: 'blur'
        //   }
        // ],
        serving_category_id: [
          { required: true, message: '请选择开发环境标签', trigger: 'change' }
        ],
        publisher_id: [
          { required: true, message: '请选择发布者', trigger: 'change' }
        ],
        // model_image_id: [
        //   { required: true, message: '请选择镜像', trigger: 'change' }
        // ],
        xpu_price_conf_id: [{ required: true, message: '选择计费方式', trigger: 'change' }],
        image_version_biz_id: [
          { required: true, message: '请选择镜像', trigger: 'change' }
        ],
        xpu_id: [
          { required: true, message: '请选择硬件配置', trigger: 'change' }
        ],
        train_mode: [
          { required: true, message: '请选择训练模式', trigger: 'change' }
        ],
      },
      addfiletype:'',
      paymethod: '',
      payfee: '',
      payList: [],
      showprice: false, //是否显示价格
      checked:false,//是否勾选自定义镜像
      modelForm: {
        serving_name_zh: '',
        // serving_name_en: '',
        serving_category_id: '',
        publisher_id: '',
        // model_image_id: '',
        image_version_biz_id:'',//镜像id
        xpu_id: '',
        time_range_id: '',
        serving_intro: '',
        train_mode: 1,
        // Datasetfile:'',
        model_path:'',
        replicas:1,
        tuning_code_path:'',
        image_version_is_public:0,
        xpu_price_conf_id:'',
      },
      selectImageName: '',
      selectXpuName: '',
      selectXputID:0,
      belence: '',
      payUnit: '',
      noMony: false,
      showTime: false,
      typeList: [],
      cluster_code:'',
      maxnode:2,//多节点最大节点数
      gpu_num:0,//gpu数量
    }
  },
  computed: {

    ownerOptions() {
      return this.$store.state.selectOptions.owner
    },
    imgOptions() {
      return this.$store.state.selectOptions.modelImages
    },
    timeRangeList() {
      return this.$store.state.selectOptions.timeRangeList
    },
    XPUInfoList() {
      return this.$store.state.selectOptions.XPUInfoList
    },
    ForTrainOptions(){
      return this.$store.state.selectOptions.getModelImagesForTrains
    },
    train_mode(){
      return this.maxnode
    }
  },
  watch: {
    checkImg: {
      handler: function (newValue, oldValue) {
        if (newValue) {
          this.modelForm.image_version_biz_id = newValue.image_version_biz_id
        }
      },
      immediate: true
    },
    train_mode(newVal, oldVal) {
      if(newVal===1){
      // this.$message.error('当前资源不足无法选择分布式')
      this.modelForm.train_mode=1
        this.modelForm.replicas=1
      }
    },
  },
  created() {   
    // console.log(this.modelsever,12312312);
    this.getModelImagelist(0)
    if(this.modelsever){
      this.cluster_code=this.modelsever.cluster_code
    }
    if(this.tuning_code_path){
        this.modelForm.tuning_code_path=this.tuning_code_path
    }
  },
  mounted() {
    let data = {}
    this.$api.project.getAccountInfo(data).then((res) => {
      this.belence = res.data.account_remain_amount
    })

    let list = this.$store.state.selectOptions.ServerTypeList
    const arr = list.map((item) => {
      return {
        label: item.name,
        value: item.id,
        pid: item.pid
      }
    })
    const tree = array2Tree(arr, {
      id: 'value',
      parentId: 'pid',
      children: 'children'
    })
    this.typeList = tree
    this.flushAccount()
  },
  methods: {
    nextFn() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (
            this.modelForm.image_version_biz_id == '' &&  !this.checked
          ) {
            alert('请选择镜像')
            return
          }
          if ( this.modelForm.xpu_id == '') {
            alert('请选择硬件配置')
            return
          }

        
        }
      })
    },
    backFn() {
      this.step = 0
    },
    //启动开发化境传递的参数
    getmoinfomes(){  
      this.modelForm=this.modelsever
      if(this.modelForm.replicas===1){
        this.modelForm.train_mode=1
      }else{
        this.modelForm.train_mode=2
      }
      let data = {
        image_version_biz_id:this.modelsever.image_version_biz_id,
        image_name:this.modelsever.image_name
      }
      if(this.modelForm.image_version_is_public==1){
        this.checked= false
        this.getModelImagelist(0)
        this.imageselect(this.modelsever.image_version_biz_id)
        this.selectImageName = data.image_name
      }else{
        this.checked= true
        this.getUserImagesName(0)
        if(this.modelsever.image_version_biz_id != ''){
          this.imageselect(this.modelsever.image_version_biz_id)
        }
        this.selectImageName = data.image_name
      }
      this.train()
    },
    //复制开发环境
    copymodeldev()
    {
      this.modelForm=this.modelsever
      if(this.modelForm.replicas===1){
        this.modelForm.train_mode=1
      }else{
        this.modelForm.train_mode=2
      }
      let data = {
        id:this.modelsever.image_version_biz_id,
        image_name:this.modelsever.image_name
      }
      if(this.modelForm.image_version_is_public==1){
        this.checked = false
        this.getModelImagelist(0)
     
      this.imageselect(this.modelsever.image_version_biz_id)
      }else{
        this.checked = true
        this.getUserImagesName(0)
        this.imageselect(this.modelsever.image_version_biz_id)
      }
      this.imageChange(data)
    },
    finishFn() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
      if ( this.modelForm.time_range_id == '') {
        this.modelForm.time_range_id = 0
      }
      if (this.modelForm.serving_category_id.length > 0) {
        this.modelForm.serving_category_id =
          this.modelForm.serving_category_id.slice(-1)[0]
      }
      this.modelForm.creator_id = this.$store.state.system.userInfo.userid
      this.disable = true
      if(this.modelsever&&this.modelForm.runmodeltype===1){
        let data={
          publisher:this.modelForm.username,
          serving_name:this.modelForm.serving_name_en,
          xpu_id:this.modelForm.xpu_id,
          time_range_id:this.modelForm.time_range_id,
          xpu_price_conf_id:this.modelForm.xpu_price_conf_id,
          serving_intro:this.modelForm.serving_intro,
          serving_category_id:this.modelForm.serving_category_id,
          xpu_id:this.modelForm.xpu_id,
          train_mode:this.modelForm.train_mode,
          replicas:this.modelForm.replicas,
          image_version_biz_id:this.modelForm.image_version_biz_id,
        }
        // console.log(data);
        
        this.$api.project.reStartModelDev(data).then((res) => {
        this.disable = false
        if (res.code == 0) {
          this.$message.success('重启成功')
          this.$emit('finish')
          this.step = 0

          for (let prop in this.modelForm) {
            if (this.modelForm.hasOwnProperty(prop)) {
              this.modelForm[prop] = '' // 或者其他初始值
            }
          }
        }
      })         
      }else{
        let result = this.$store.state.selectOptions.owner.filter(item => item.id==this.modelForm.publisher_id);
        let data ={
          serving_name:'',
          username:result[0].name
        }
        // if(this.checked){
        //   this.modelForm.image_version_biz_id=''
        // }
        this.$api.project.createModelDev(this.modelForm).then((res) => {
        this.disable = false
        if (res.code == 0) {
          this.$message.success('创建成功')
          data.serving_name = res.data
          this.$emit('finish',data)
          this.step = 0
          // this.modelForm[prop] = ''
          for (let prop in this.modelForm) {
            if (this.modelForm.hasOwnProperty(prop)) {
              this.modelForm[prop] = '' // 或者其他初始值
            }
              }
            }
          })
          } 
        }
      })
    },
    imgc(e){
      this.selectImageName = e.image_name
      this.imagesSelect(e)
    },
    imageChange(e) {      
      this.selectImageName = e.image_name
      if(this.modelsever?this.modelsever.runmodeltype==2:false){
        this.$store.state.selectOptions.XPUInfoList.forEach(item => {          
                if(item.id==this.modelsever.xpu_id){
                  this.xpuList=[]
                  this.xpuList.push(item)
                  this.xpuChange(item)
                }
        });
      }
   
    },
    upxouinfo(e){
      let xpulist = [...this.$store.state.selectOptions.XPUInfoList]   
      const canusexpu = xpulist.filter(item =>item.status===0)
      this.xpuList=[...canusexpu] 
      if(e){
        this.xpuList.forEach(item => {
          if(item.id==e.id){
            this.modelForm.xpu_id=e.id
            this.xpuChange(item)
          }
      });
      }
        
    },
    //分布式多节点加减
    setreplicas(val){
      if(this.belence  < val * this.payfee){
        this.noMony = true
      }else{
        this.noMony = false
      }
    },
    //镜像选中填写信息
    imagesSelect(e)
    {
        this.modelForm.publisher_id = this.ownerOptions[0].id
        if(!e.is_base || e.is_base == 0){
          this.modelForm.serving_name_zh = this.processString(e.image_name)
        }else{
          this.modelForm.serving_name_zh=''
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate(['serving_name_zh'])
          })
        }
        if(e.model_path){
          this.modelForm.model_path = e.model_path
        }
        if(e.category_id!==0){
          let modelType = getFullByLastIdFromTree(
              this.$store.state.selectOptions.ServerTypeList,
              e.category_id
             )
        this.modelForm.serving_category_id=modelType
        }else{
          this.modelForm.serving_category_id=''
        }
    },
    processString(str) 
    {
        str = str.replace(/:/g, '-')
        const index = str.indexOf('/');
        if (index !== -1) {
          return str.slice(index + 1);
        }
        return str;
      },
    //训练或微调显示全部配置
    train(){
      this.xpuList=[]
      let xpulist = [...this.$store.state.selectOptions.XPUInfoList]   
      const canusexpu = xpulist.filter(item =>item.status===0)
      this.xpuList=[...canusexpu]   
    },
    //镜像选中值改变
    imageselect(e){
      let data ={
        biz_id:e
      }
      this.$api.project.getXPUInfosByImageVersionBizId(data).then(res=>{  
        this.xpuList = [...res.data]
        if(this.modelForm.xpu_id!='' && this.modelsever){
          this.xpuList.forEach(item => {
                if(item.id==this.modelsever.xpu_id){
                  this.xpuChange(item)
                }
        });
          const isIdPresent = this.xpuList.every(item => item.id !== this.modelForm.xpu_id);
          if(isIdPresent){
            this.modelForm.xpu_id=''
          }
        }
      })
    
    },
    //获取镜像列表
    getModelImagelist(e){
        let data ={
          xpu_id:e
        }
        if(this.selectdevimgbizid){
          data.image_biz_id=this.selectdevimgbizid
        }
        this.$api.project.getmodelimagelist(data).then((res) => {
          this.imagedatalist = [...res.data]
          if(this.imagedatalist.length==1){
            this.modelForm.image_version_biz_id=this.imagedatalist[0].image_version_biz_id
            this.imageChange(this.imagedatalist[0])
            this.imageselect(this.imagedatalist[0].image_version_biz_id)
            this.imgc(this.imagedatalist[0])
          }
     
        })
    },
    getUserImagesName(e){
      let data = {
        image_type:'train',
        xpu_id:e
        //project_model_id后面模型详情点击训练微调会用，可以从哪里取到传值
      }
      this.$api.project.getUserImagesName(data).then((res) => {
        this.imagedatalist=[...res.data]
        if(this.imagedatalist.length===0){
            this.$message.error('个人镜像库没有镜像或没有关联对应xpu配置的镜像，请先上传镜像')
          }
      })
    },
    //删除路径
    delmodelfile(){
      this.modelForm.model_path=''
      if(!this.modelsever){
        this.$refs.fileaddress.close()
      }
    },
    xpuChange(e) {
     this.cluster_code=e.cluster_code
      this.selectXpuName = e.xpu_name
      this.selectXputID = e.id
      this.gpu_num = e.gpu_num
      let data = {
        xpu_id: e.id,
        is_share_res: 0
      }
      if(this.modelForm.train_mode==2){
        this.modelForm.replicas=2
      }
      if(this.modelForm.train_mode==1){
        this.modelForm.replicas=1
      }
      //根据选择配置查询资源是否可用
      this.$api.project.verifyGpuIsEnough(data).then((res) => {
        if(res.data==0){
          this.disable = true
        }
          if(res.data>0){
            this.disable = false
            this.maxnode=res.data 
          }
        if(e.gpu_num==0 && res.data==0){
          this.disable = false
          this.maxnode=res.data
        }
      })
      //根据选择配置查询价格配置
      this.$api.project.getxpuCharg(data).then((res) => {
        this.payList = res.data
        this.modelForm.xpu_price_conf_id = res.data[0].id
        this.showprice = true
        this.payfee = res.data[0].price
        if (res.data[0].type_name_en == 'flow') {
          this.showTime = true
          this.payUnit = '小时'
        }
        if (res.data[0].type_name_en == 'day') {
          this.payUnit = '天'
        }
        if (res.data[0].type_name_en == 'week') {
          this.payUnit = '周'
        }
        if (res.data[0].type_name_en == 'month') {
          this.payUnit = '月'
        }
        if (res.data[0].type_name_en == 'year') {
          this.payUnit = '年'
        }
        if (this.belence < this.modelForm.replicas * this.payfee) {
          this.noMony = true
        }
        this.payChange(this.payList[this.payList.findIndex(item => item.id === this.modelForm.xpu_price_conf_id)])
      })
   
    },
    closenewcp(){
    
    },
    //选择镜像获得焦点
    imagefocus(e){
   
     if(e){
        if(this.selectXputID===0 && this.selectImageName===''){
            if(this.checked){
              this.getUserImagesName(0)
            }else{
              this.getModelImagelist(0)
            }
       }
      if(this.selectXputID!==0){
        if(this.checked){
          this.getUserImagesName(this.selectXputID)
        }else{
          this.getModelImagelist(this.selectXputID)
        }
      }
    }    
    
    },
    checkuserimage(val){
      this.modelForm.image_version_biz_id=''
      this.modelForm.serving_name_zh=''
      this.modelForm.xpu_id=''
      this.selectXputID=0
      this.showprice = false
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate(['serving_name_zh'])
      })
      // this.modelForm.xpu_id = ''
      this.imagedatalist=[]
      if(this.checked){
        this.getUserImagesName(this.selectXputID)
      }else{
         this.getModelImagelist(this.selectXputID)
     }
    },
    getinput(e){
      this.modelForm.replicas=e
      this.modelForm.train_mode=e
      let data = {
        xpu_id: this.selectXputID,
        is_share_res: 0
      }
      this.payChange(this.payList[this.payList.findIndex(item => item.id === this.modelForm.xpu_price_conf_id)])
      //单点分布切换查询资源是否可用
      if(this.selectXputID>0){
        this.$api.project.verifyGpuIsEnough(data).then((res) => {
        if(!res.data){
          this.disable = true
        }
          if(res.data>0){
            this.disable = false
            this.maxnode=res.data
          }
      })
      }
    },
    payChange(e) {
      this.payfee = e.price
      this.payUnit = e.type_name_en
      if (this.belence < this.modelForm.replicas * e.price) {
        this.noMony = true  
      } else {
        this.noMony = false
      }
      if (e.type_name_en == 'flow') {
        this.showTime = true
        this.payUnit = '小时'
      } else {
        this.showTime = false
      }
      if (e.type_name_en == 'day') {
        this.payUnit = '天'
      }
      if (e.type_name_en == 'week') {
        this.payUnit = '周'
      }
      if (e.type_name_en == 'month') {
        this.payUnit = '月'
      }
      if (e.type_name_en == 'year') {
        this.payUnit = '年'
      }
    },
    pay() {
      this.modelVisible = true
    },
    closeModel() {
      this.modelVisible = false
    },
    closefile() {
      this.filemodel= false
    },
    close() {
      this.step = 0
      this.$nextTick(() => {
        this.$refs.ruleForm.resetFields()
      })
      this.modelForm.serving_category_id = ''
      this.showprice = false
      this.checked=false
    },
    //关闭弹窗
    closeModel() {
      this.modelVisible = false
    },

    flushAccount() {
      let data = {}
      this.$api.project.getAccountInfo(data).then((res) => {
        this.belence = res.data.account_remain_amount
        if (this.belence >= this.modelForm.replicas * this.payfee) {
          this.noMony = false
        }
      })
    },
    finiFN(e){
        this.filemodel=false
        if(e!='请选择或输入文件地址' && this.addfiletype=='model'){
          this.modelForm.model_path=e
        }
        if(e!='请选择或输入文件地址' && this.addfiletype=='data'){
          this.modelForm.Datasetfile=e
        }
    },

    addmodelfile(e){
      if(this.modelForm.xpu_id==''){
        this.$message.error('请先选择资源配置')
        return
      }
      this.addfiletype=e
      this.filemodel=true
      this.$nextTick(()=>{
          this.$refs.fileaddress.getShareFileList(this.cluster_code)
      })
    },  
  }
}
</script>
<style lang="scss" scoped>

.items {
  margin-bottom: 20px;
  font-size: 18px;
  color: #000;
}

.money-warning {
  color: #dd1d1d;
}

.warning-icon {
  width: 20px;
}

.pay-btn {
  border-radius: 5px;
  padding: 2px 10px;
  background: #dd1d1d;
  color: #fff;
  cursor: pointer;
}

.footer {
  height: 60px;
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #f4e9ff;
}

::v-deep {
  .el-input .el-input__inner {
    height: auto;
  }
 
@media only screen and (max-width: 767px) {
  .el-form .el-form-item__label{
    min-width: 1.5rem;
}
.el-form .el-form-item{
  min-width: none;
  display: block;
  margin-bottom: 50px;
}
}
}
.number-input {
  display: flex;
  align-items: center;
}
.tips {
  right: -35px;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  display: flex;
  align-items: center;
}


</style>
